import { render, staticRenderFns } from "./ShopDetails.vue?vue&type=template&id=158a56df&scoped=true&"
import script from "./ShopDetails.vue?vue&type=script&lang=js&"
export * from "./ShopDetails.vue?vue&type=script&lang=js&"
import style0 from "./ShopDetails.vue?vue&type=style&index=0&id=158a56df&lang=scss&scoped=true&"
import style1 from "./ShopDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158a56df",
  null
  
)

export default component.exports